import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createContinuousAccessTaskFailedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.CONTINUOUS_ACCESS_TASK_FAILED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            ...getCompany(),
            ...getConnector(),
            reason: 'unknown-error',
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=continuous-access-task-failed.js.map